<template>
    <div>
        <div class="d-flex brand-book-gallery">
            <div
                v-for="(image, index) in images"
                :key="image.src"
                @click="selectedIndex = index"
                class="cursor-pointer border border-solid border-2 mb-4 flex-item-grow"
                :class="{
                    'border-default-5': selectedIndex === index,
                }"
                style="border-color: transparent"
            >
                <div class="pos-relative aspect aspect-xs-1-1">
                    <div
                        class="pos-absolute pos-top pos-left w-full h-full d-flex flex-align-center"
                        :class="addPadding ? 'px' : null"
                    >
                        <picture class="w-full">
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/site/2021/brand-book/${image.src}?auto=compress,format&q=65&w=300`"
                                :alt="image.alt"
                                class="img-responsive"
                            />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-for="(image, index) in images"
            v-show="selectedIndex === index"
            :key="image.src"
            class="pos-relative"
            :class="square ? ' aspect aspect-xs-1-1' : null"
        >
            <div
                class="pos-absolute pos-top pos-left w-full d-flex flex-align-center"
                :class="square ? 'h-full' : null"
            >
                <picture class="w-full">
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/site/2021/brand-book/${image.src}?auto=compress,format&q=65&w=1000`"
                        :alt="image.alt"
                        class="img-responsive"
                    />
                </picture>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BrandBookGallery',

        props: {
            images: {
                type: Array,
                required: true,
            },
            addPadding: Boolean,
            square: Boolean,
        },

        data() {
            return {
                selectedIndex: 0,
            };
        },
    };
</script>
